<template>
  <Container>
    <rotate-square6 v-if="this.loading2"></rotate-square6>
    <div class="worklist" v-if="!this.loading2">
      <WorkThumb
        v-for="work in works"
        :key="work.id"
        :name="work.title.rendered"
        :slug="work.slug"
        :image="work.featured_media ? work._embedded['wp:featuredmedia'][0].source_url : require('@/assets/images/thumb.png')"
        :client="work.cmb2['pt-work-mb']['pt-work-mb__client']"
      />
    </div>
  </Container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import RotateSquare6 from "vue-loading-spinner/src/components/RotateSquare6";

import Container from "@/components/Container";
import WorkThumb from "@/components/WorkThumb";

export default {
  name: "worklist",
  components: {
    WorkThumb,
    Container,
    RotateSquare6
  },
  methods: {
    ...mapActions("works", ["all", "setLoad"])
  },
  data: () => ({
    loading2: true
  }),
  computed: {
    // ...mapState("works", {
    //   loading: "loading"
    // }),
    ...mapGetters("works", {
      works: "filtered",
      loaded: "loaded"
    })
  },
  async created() {
    // await this.rewind();
    await this.all();
    await this.setLoad();
    this.loading2 = false;
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";

.worklist {
  display: grid;

  padding: 8.3rem 0 22.3rem;

  grid-template-columns: 1fr 1fr 1fr;

  gap: 7.5rem 3.1rem;

  @media (min-width: $min-sm) and (max-width: $max-sm) {
    gap: 4rem 1.7rem;
  }
  @media (max-width: $max-xs) {
    padding: 5rem 0 6rem;

    grid-template-columns: 1fr 1fr;

    gap: 6rem 1.7rem;
  }
}
</style>

<style lang="scss">
.spinner {
  width: initial !important;
  height: 20rem !important;
}
</style>
